var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgStar = function SvgStar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 18,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#797979",
    d: "M7.514 0c.173.914.336 1.831.522 2.742.306 1.505.951 2.785 1.903 3.824.922 1.008 2.015 1.633 3.246 1.917.606.14 1.205.32 1.815.533l-.417.118c-.769.22-1.558.369-2.303.673-2.29.937-3.71 2.857-4.288 5.664-.172.834-.318 1.676-.512 2.517-.098-.515-.197-1.029-.292-1.545-.179-.966-.342-1.938-.737-2.823-.977-2.192-2.483-3.546-4.511-4.076A25.07 25.07 0 0 1 0 8.971c.146-.042.292-.084.439-.124.666-.183 1.344-.317 1.995-.556 2.528-.927 4.053-2.97 4.623-6.05.139-.747.28-1.492.421-2.239L7.514 0Z"
  })));
};
export default SvgStar;